import React from 'react';
import { TimelineForm } from '../../components/Timeline'
import { InteractiveWrapper } from '../../components/Interface';
import { Timeline as TimelineTemplate } from '../../components/Templates';

export const Timeline = () => {
    return (
      <InteractiveWrapper 
        name="timeline"
        title="Timeline"
        template={TimelineTemplate}
        initFunction="initTimeline"
        hasStyles={true}
        topPadding={true}
      >
        <TimelineForm />
      </InteractiveWrapper>
    )
}